import { useNavigate } from "react-router-dom";
import { ReactComponent as LogoSBP } from "../assets/sbp-logo.svg";
import { ReactComponent as LogoSberPay } from "../assets/sber_pay.svg";
import { ReactComponent as LogoTPay } from "../assets/Tinkoff-Pay.svg";
import css from "./Buy.module.css"
import {useEffect, useState} from "react";

const BuyPage = () => {
    const navigate = useNavigate();

    const [selectedProduct, setSelectedProduct] = useState({
        id: 1,
        product_key: "null",
        title: "Загрузка",
        description: "загружаем данные",
        price_rub: 0,
    });
    const [products, setProducts] = useState([{
        id: 1,
        product_key: "null",
        title: "Загрузка",
        description: "загружаем данные",
        price_rub: 0,
    }]);
    const [email, setEmail] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("sbp");
    const [error, setError] = useState("");




    const selectPlan = (p) => {
        setSelectedProduct(p);
    }

    document.body.style.zoom = 1

    const particles = Array.from({length: 30}, (_, i) => (
        <div className={css.particle} key={i}
             style={{left: Math.random() * 100 + "%", animationDelay: Math.random() * 15 + "s", animationDuration: (Math.random() * 10 + 10) + "s"}}>
        </div>
    ));

    const toPay = async () => {
        setError("");
        try {
            const result = await buySubscription(email, selectedProduct.product_key, paymentMethod);
            if (typeof result === 'string') {
                setError("Что-то пошло не так. Сообщите в поддержку!");
            } else {
                localStorage.setItem("email", email)
                localStorage.setItem("payment_id", result.payment_id)
                window.location.replace(result.url);
            }
        } catch (err) {
            setError("Ошибка при загрузке данных. Попробуйте позже.");
        }
    }

    useEffect(() => {
        GetProducts().then((res) => {
            setProducts(res);
            selectPlan(res[1]);
        })
    }, [])

    return (
        <>
            <div className={css.bgGrid}></div>
            <div className={`${css.bgGlow} ${css.bgGlow1}`}></div>
            <div className={`${css.bgGlow} ${css.bgGlow2}`}></div>
            <div className="particles" id={css.particles}>
                {particles}
            </div>

            <div className={css.wrap}>

                <div className={css.header}>
                    <h1>Оформление подписки</h1>
                    <p>Выберите тариф и начните пользоваться защищённым интернетом</p>
                </div>

                <div className={css.plans} id="plans">
                    {products.map(p => (
                        <div className={css.plan + (selectedProduct.id === p.id ? ` ${css.active}` : "")} key={p.id} onClick={() => selectPlan(p)}>
                            {selectedProduct.id === p.id ? (<div className={css.planBadge}>Выбрано</div>) : ""}
                            <div className={css.planDuration}>{p.title}</div>
                            <div className={css.planPrice}>{p.price_rub} ₽</div>
                            <div className={css.planPer}>{p.description}</div>
                        </div>
                    ))}
                </div>

                <div className={css.formSection}>

                    <div className={css.formGroup}>
                        <label className={css.formLabel}>Электронная почта</label>
                        <input
                            type="email"
                            id="email"
                            className={css.formInput}
                            placeholder="your@email.com"
                            required
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className={css.formGroup}>
                        <label className={css.formLabel}>Способ оплаты</label>
                        <div className={css.paymentMethods} id="paymentMethods">

                            <label className={css.paymentMethod + (paymentMethod === "sbp"? ` ${css.active}` : "")} onClick={()=>setPaymentMethod("sbp")}>
                                <input type="radio" name="payment" value="sbp" checked/>
                                <div className={css.paymentRec}>рекомендуем</div>
                                <div className={css.paymentLogoSBP}>
                                    <LogoSBP />
                                </div>
                                <div className={css.paymentName}>СБП</div>
                                <div className={css.paymentDesc}>Система быстрых платежей</div>
                            </label>

                            <label className={css.paymentMethod + (paymentMethod === "sberbank"? ` ${css.active}` : "")} onClick={()=>setPaymentMethod("sberbank")}>
                                <input type="radio" name="payment" value="sberbank" />
                                <div className={css.paymentRec}>рекомендуем</div>
                                <div className={css.paymentLogoSBP}>
                                    <LogoSberPay />
                                </div>
                                <div className={css.paymentName}>SberPay</div>
                                <div className={css.paymentDesc}>Оплата через Сбер ID или мобильное приложение Сбербанк Онлайн</div>
                            </label>

                            <label className={css.paymentMethod + (paymentMethod === "tinkoff_bank"? ` ${css.active}` : "")} onClick={()=>setPaymentMethod("tinkoff_bank")}>
                                <input type="radio" name="payment" value="tinkoff_bank" />
                                <div className={css.paymentRec}>рекомендуем</div>
                                <div className={css.paymentLogoSBP}>
                                    <LogoTPay />
                                </div>
                                <div className={css.paymentName}>T-Pay</div>
                                <div className={css.paymentDesc}>Оплата через T-ID или мобильное приложение T-Банк</div>
                            </label>

                            <label className={css.paymentMethod + (paymentMethod === "bank_card"? ` ${css.active}` : "")} onClick={()=>setPaymentMethod("bank_card")}>
                                <input type="radio" name="payment" value="bank_card"/>
                                <div className={css.paymentLogoCard}>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                         stroke-linecap="round" stroke-linejoin="round">
                                        <rect x="2" y="5" width="20" height="14" rx="2"/>
                                        <line x1="2" y1="10" x2="22" y2="10"/>
                                        <line x1="6" y1="15" x2="10" y2="15"/>
                                    </svg>
                                </div>
                                <div className={css.paymentName}>Банковская карта</div>
                                <div className={css.paymentDesc}>Visa, Mastercard, МИР</div>
                            </label>

                        </div>
                    </div>
                    {error && (<p color={"red"}>{error}</p>)}
                    <button className={css.btnPay} id="payBtn" type="button" onClick={toPay}>
                        Оплатить <span id="payPrice">{selectedProduct.price_rub} ₽</span>
                    </button>

                </div>

            </div>
        </>
    );
};

async function buySubscription(email, type, method) {
    try {
        const url = "https://api.bezopas.net/pay/yookassa/payments";

        const response = await fetch(url, {
            method: "POST",
            body: JSON.stringify({
                email: email,
                method: method,
                type: type,
                return_url: "https://bezopas.net/payment-check"
            })
        });
        if (response.status === 404) return "Not found";
        if (response.status === 400) return "Bad Request";
        if (!response.ok) return "Server Error";
        return response.json();
    } catch {
        return "Server Error";
    }
}

async function GetProducts() {
    try {
        const url = "https://api.bezopas.net/products/";

        const response = await fetch(url, {method: "GET"});
        if (response.status === 404) return "Not found";
        if (response.status === 400) return "Bad Request";
        if (!response.ok) return "Server Error";
        return response.json();
    } catch {
        return "Server Error";
    }
}

async function GetProductByKey(key) {
    try {
        const url = "https://api.bezopas.net/products/" + key;

        const response = await fetch(url, {method: "GET"});
        if (response.status === 404) return "Not found";
        if (response.status === 400) return "Bad Request";
        if (!response.ok) return "Server Error";
        return response.json();
    } catch {
        return "Server Error";
    }
}



export default BuyPage;